<mat-form-field class="w-full">
    <mat-label>{{label}}</mat-label>
    <mat-select [formControl]="selectControl" [disabled]="disabled">
        @for (option of options; track option) {
        <mat-option [value]="option.value">{{option.viewValue}}</mat-option>
        }
    </mat-select>
</mat-form-field>